import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    custom_period: 'Custom period',
    from: 'From',
    next: 'Next',
    pick_timeframe: 'Pick a timeframe',
    title: 'For which period?',
    to: 'To',
  },
  fr: {
    custom_period: 'Période personnalisée',
    from: 'Du',
    next: 'Suivant',
    pick_timeframe: 'Choisir les dates',
    title: 'Sur quelle période ?',
    to: 'Au',
  },
});

export default locales;
